import builder from '../builder';
import CheckBadgeAlternate from '../../streamline-icons/bold/check-badge-alternate.svg';

export default builder('IconCheckBadgeAlternateBold', CheckBadgeAlternate);
